import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";
import {
    FiShield,
    FiLock,
    FiSmartphone,
    FiMonitor,
    FiLogOut,
    FiCheckCircle,
    FiAlertCircle,
    FiEye,
    FiEyeOff,
    FiKey,
    FiSave,
    FiX,
} from "react-icons/fi";

export default function Security() {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOtp] = useState("");
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false,
    });

    // Password form state
    const [passwordForm, setPasswordForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    // Security settings state
    const [securitySettings, setSecuritySettings] = useState({
        twoFactorEnabled: false,
        loginAlerts: true,
    });

    // Static data - Active devices/sessions
    const [activeSessions, setActiveSessions] = useState([
        {
            id: 1,
            device: "Windows PC",
            browser: "Chrome",
            location: "Mumbai, India",
            ipAddress: "192.168.1.100",
            lastActive: "2024-01-22T14:30:00",
            isCurrent: true,
        },
        {
            id: 2,
            device: "iPhone 13",
            browser: "Safari",
            location: "Mumbai, India",
            ipAddress: "192.168.1.101",
            lastActive: "2024-01-22T10:15:00",
            isCurrent: false,
        },
        {
            id: 3,
            device: "MacBook Pro",
            browser: "Chrome",
            location: "Delhi, India",
            ipAddress: "203.0.113.45",
            lastActive: "2024-01-20T09:00:00",
            isCurrent: false,
        },
    ]);

    const handlePasswordInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();

        // Validate passwords
        if (passwordForm.newPassword.length < 8) {
            alert("New password must be at least 8 characters long.");
            return;
        }

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            alert("New password and confirm password do not match.");
            return;
        }

        // Show OTP modal for sensitive action
        setShowOTPModal(true);
    };

    const handleVerifyOTPAndChangePassword = () => {
        if (otp.length === 6) {
            setIsSubmitting(true);
            setTimeout(() => {
                alert("Password changed successfully!");
                setPasswordForm({
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: "",
                });
                setShowChangePassword(false);
                setShowOTPModal(false);
                setOtp("");
                setIsSubmitting(false);
            }, 1000);
        } else {
            alert("Please enter a valid 6-digit OTP");
        }
    };

    const handleToggle2FA = () => {
        if (!securitySettings.twoFactorEnabled) {
            // Enable 2FA - show OTP modal
            setShowOTPModal(true);
            setTimeout(() => {
                setSecuritySettings((prev) => ({ ...prev, twoFactorEnabled: true }));
                setShowOTPModal(false);
                setOtp("");
                alert("Two-Factor Authentication enabled successfully!");
            }, 1000);
        } else {
            // Disable 2FA - show OTP modal
            setShowOTPModal(true);
            setTimeout(() => {
                setSecuritySettings((prev) => ({ ...prev, twoFactorEnabled: false }));
                setShowOTPModal(false);
                setOtp("");
                alert("Two-Factor Authentication disabled successfully!");
            }, 1000);
        }
    };

    const handleLogoutDevice = (sessionId) => {
        if (window.confirm("Are you sure you want to logout from this device?")) {
            setActiveSessions((prev) => prev.filter((s) => s.id !== sessionId));
            alert("Device logged out successfully!");
        }
    };

    const handleLogoutAllDevices = () => {
        if (window.confirm("Are you sure you want to logout from all devices except this one?")) {
            setActiveSessions((prev) => prev.filter((s) => s.isCurrent));
            alert("All other devices logged out successfully!");
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <>
            <ClientNavbar />
            <div className="page-content" style={{ background: "#f8fafc" }}>
                    {/* Header */}
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                    <h3 className="mb-2 text-primary">Security Settings</h3>
                                    <nav
                                        aria-label="breadcrumb"
                                        style={{ "--bs-breadcrumb-divider": "none" }}
                                    >
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <NavLink to="/overview">Dashboard</NavLink> /
                                            </li>
                                            <li className="breadcrumb-item">
                                                <NavLink to="/account/security">Account</NavLink> /
                                            </li>
                                            <li className="breadcrumb-item active">Security Settings</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        {/* Change Password */}
                        <div className="col-lg-6">
                            <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                <div
                                    className="card-header border-0 py-3 px-4"
                                    style={{
                                        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                                        borderBottom: "1px solid #b3eaf4",
                                    }}
                                >
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div
                                                className="me-3 d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "10px",
                                                    background: "#c8eeecbf",
                                                }}
                                            >
                                                <FiLock style={{ color: "#39b2b4", fontSize: "20px" }} />
                                            </div>
                                            <h5 className="mb-0 me-3 fw-bold" style={{ color: "#006e82" }}>
                                                Change Password
                                            </h5>
                                        </div>
                                        {!showChangePassword && (
                                            <button
                                                className="btn btn-sm fw-semibold"
                                                onClick={() => setShowChangePassword(true)}
                                                style={{
                                                    borderRadius: "8px",
                                                    background: "linear-gradient(135deg, #39b2b4 0%, #06b6a4 100%)",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Change Password
                                            </button>
                                        )}
                                    </div>
                                </div>
                                {showChangePassword && (
                                    <div className="card-body p-4">
                                        <form onSubmit={handleChangePassword}>
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold mb-2" style={{ color: "#006e82" }}>
                                                    Current Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPasswords.current ? "text" : "password"}
                                                        className="form-control"
                                                        name="currentPassword"
                                                        value={passwordForm.currentPassword}
                                                        onChange={handlePasswordInputChange}
                                                        required
                                                        style={{
                                                            borderRadius: "10px 0 0 10px",
                                                            borderColor: "#b3eaf4",
                                                            fontSize: "14px",
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="input-group-text border-start-0"
                                                        onClick={() =>
                                                            setShowPasswords((prev) => ({ ...prev, current: !prev.current }))
                                                        }
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderColor: "#b3eaf4",
                                                            borderRadius: "0 10px 10px 0",
                                                            borderLeft: "none",
                                                        }}
                                                    >
                                                        {showPasswords.current ? (
                                                            <FiEyeOff style={{ color: "#006e82" }} />
                                                        ) : (
                                                            <FiEye style={{ color: "#006e82" }} />
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold mb-2" style={{ color: "#006e82" }}>
                                                    New Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPasswords.new ? "text" : "password"}
                                                        className="form-control"
                                                        name="newPassword"
                                                        value={passwordForm.newPassword}
                                                        onChange={handlePasswordInputChange}
                                                        required
                                                        minLength={8}
                                                        style={{
                                                            borderRadius: "10px 0 0 10px",
                                                            borderColor: "#b3eaf4",
                                                            fontSize: "14px",
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="input-group-text border-start-0"
                                                        onClick={() =>
                                                            setShowPasswords((prev) => ({ ...prev, new: !prev.new }))
                                                        }
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderColor: "#b3eaf4",
                                                            borderRadius: "0 10px 10px 0",
                                                            borderLeft: "none",
                                                        }}
                                                    >
                                                        {showPasswords.new ? (
                                                            <FiEyeOff style={{ color: "#006e82" }} />
                                                        ) : (
                                                            <FiEye style={{ color: "#006e82" }} />
                                                        )}
                                                    </button>
                                                </div>
                                                <div className="form-text" style={{ fontSize: "12px", color: "#64748b" }}>
                                                    Password must be at least 8 characters long
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold mb-2" style={{ color: "#006e82" }}>
                                                    Confirm New Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPasswords.confirm ? "text" : "password"}
                                                        className="form-control"
                                                        name="confirmPassword"
                                                        value={passwordForm.confirmPassword}
                                                        onChange={handlePasswordInputChange}
                                                        required
                                                        style={{
                                                            borderRadius: "10px 0 0 10px",
                                                            borderColor: "#b3eaf4",
                                                            fontSize: "14px",
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="input-group-text border-start-0"
                                                        onClick={() =>
                                                            setShowPasswords((prev) => ({ ...prev, confirm: !prev.confirm }))
                                                        }
                                                        style={{
                                                            backgroundColor: "#ccf1f7",
                                                            borderColor: "#b3eaf4",
                                                            borderRadius: "0 10px 10px 0",
                                                            borderLeft: "none",
                                                        }}
                                                    >
                                                        {showPasswords.confirm ? (
                                                            <FiEyeOff style={{ color: "#006e82" }} />
                                                        ) : (
                                                            <FiEye style={{ color: "#006e82" }} />
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <button
                                                    type="submit"
                                                    className="btn fw-semibold"
                                                    style={{
                                                        borderRadius: "10px",
                                                        background: "linear-gradient(135deg, #39b2b4 0%, #06b6a4 100%)",
                                                        color: "white",
                                                        border: "none",
                                                        padding: "10px 24px",
                                                    }}
                                                >
                                                    {/* <FiKey className="me-2" /> */}
                                                    Change Password
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn fw-semibold"
                                                    onClick={() => {
                                                        setShowChangePassword(false);
                                                        setPasswordForm({
                                                            currentPassword: "",
                                                            newPassword: "",
                                                            confirmPassword: "",
                                                        });
                                                    }}
                                                    style={{
                                                        borderRadius: "10px",
                                                        borderColor: "#b3eaf4",
                                                        color: "#006e82",
                                                        backgroundColor: "transparent",
                                                        padding: "10px 24px",
                                                    }}
                                                >
                                                    {/* <FiX className="me-2" /> */}
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                )}
                            </div>

                            {/* Two-Factor Authentication */}
                            <div className="card shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                <div
                                    className="card-header border-0 py-3 px-4"
                                    style={{
                                        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                                        borderBottom: "1px solid #b3eaf4",
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="me-3 d-flex align-items-center justify-content-center"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "10px",
                                                background: "#c8eeecbf",
                                            }}
                                        >
                                            <FiShield style={{ color: "#39b2b4", fontSize: "20px" }} />
                                        </div>
                                        <h5 className="mb-0 fw-bold" style={{ color: "#006e82" }}>
                                            Two-Factor Authentication
                                        </h5>
                                    </div>
                                </div>
                                <div className="card-body p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h6 className="fw-semibold mb-1" style={{ color: "#006e82" }}>
                                                {securitySettings.twoFactorEnabled ? "2FA Enabled" : "2FA Disabled"}
                                            </h6>
                                            <p className="mb-0" style={{ color: "#64748b", fontSize: "13px" }}>
                                                {securitySettings.twoFactorEnabled
                                                    ? "An additional layer of security is protecting your account."
                                                    : "Add an extra layer of security to your account."}
                                            </p>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={securitySettings.twoFactorEnabled}
                                                onChange={handleToggle2FA}
                                                style={{
                                                    width: "48px",
                                                    height: "24px",
                                                    cursor: "pointer",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {securitySettings.twoFactorEnabled && (
                                        <div
                                            className="alert py-2 mb-0 border-0"
                                            style={{
                                                borderRadius: "8px",
                                                backgroundColor: "#d1fae5",
                                                border: "1px solid #10b981",
                                                color: "#065f46",
                                                fontSize: "12px",
                                            }}
                                        >
                                            <FiCheckCircle className="me-2" />
                                            2FA is active. You'll receive OTP codes for sensitive actions.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Active Sessions */}
                        <div className="col-lg-6">
                            <div className="card shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                <div
                                    className="card-header border-0 py-3 px-4 d-flex justify-content-between align-items-center"
                                    style={{
                                        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                                        borderBottom: "1px solid #b3eaf4",
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="me-3 d-flex align-items-center justify-content-center"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                borderRadius: "10px",
                                                background: "#c8eeecbf",
                                            }}
                                        >
                                            <FiMonitor style={{ color: "#39b2b4", fontSize: "20px" }} />
                                        </div>
                                        <h5 className="mb-0 fw-bold" style={{ color: "#006e82" }}>
                                            Active Sessions
                                        </h5>
                                    </div>
                                    {activeSessions.filter((s) => !s.isCurrent).length > 0 && (
                                        <button
                                            className="btn btn-sm fw-semibold"
                                            onClick={handleLogoutAllDevices}
                                            style={{
                                                borderRadius: "8px",
                                                borderColor: "#ef4444",
                                                color: "#ef4444",
                                                backgroundColor: "transparent",
                                            }}
                                        >
                                            <FiLogOut className="me-1" />
                                            Logout All
                                        </button>
                                    )}
                                </div>
                                <div className="card-body p-4">
                                    {activeSessions.map((session) => (
                                        <div
                                            key={session.id}
                                            className="mb-3 p-3 rounded"
                                            style={{
                                                backgroundColor: session.isCurrent ? "#f0f9ff" : "#ffffff",
                                                border: `2px solid ${session.isCurrent ? "#39b2b4" : "#e9ecef"}`,
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div className="flex-grow-1">
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        {session.device.includes("iPhone") || session.device.includes("Android") ? (
                                                            <FiSmartphone style={{ color: "#39b2b4", fontSize: "18px" }} />
                                                        ) : (
                                                            <FiMonitor style={{ color: "#39b2b4", fontSize: "18px" }} />
                                                        )}
                                                        <h6 className="mb-0 fw-bold" style={{ color: "#006e82", fontSize: "14px" }}>
                                                            {session.device}
                                                        </h6>
                                                        {session.isCurrent && (
                                                            <span
                                                                className="badge px-2 py-1"
                                                                style={{
                                                                    fontSize: "10px",
                                                                    background: "#39b2b4",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                Current
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div style={{ color: "#64748b", fontSize: "12px" }}>
                                                        <div>{session.browser}</div>
                                                        <div>{session.location}</div>
                                                        <div>IP: {session.ipAddress}</div>
                                                        <div className="mt-1">Last active: {formatDate(session.lastActive)}</div>
                                                    </div>
                                                </div>
                                                {!session.isCurrent && (
                                                    <button
                                                        className="btn btn-sm"
                                                        onClick={() => handleLogoutDevice(session.id)}
                                                        style={{
                                                            borderRadius: "6px",
                                                            borderColor: "#ef4444",
                                                            color: "#ef4444",
                                                            backgroundColor: "transparent",
                                                        }}
                                                        title="Logout"
                                                    >
                                                        <FiLogOut style={{ fontSize: "14px" }} />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Login Alerts */}
                    <div className="card shadow-sm border-0 mt-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                        <div
                            className="card-header border-0 py-3 px-4"
                            style={{
                                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                                borderBottom: "1px solid #b3eaf4",
                            }}
                        >
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div
                                        className="me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "10px",
                                            background: "#c8eeecbf",
                                        }}
                                    >
                                        <FiAlertCircle style={{ color: "#39b2b4", fontSize: "20px" }} />
                                    </div>
                                    <div>
                                        <h5 className="mb-0 fw-bold" style={{ color: "#006e82" }}>
                                            Login Alerts
                                        </h5>
                                        <p className="mb-0" style={{ color: "#64748b", fontSize: "12px" }}>
                                            Get notified when someone logs into your account
                                        </p>
                                    </div>
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={securitySettings.loginAlerts}
                                        onChange={(e) =>
                                            setSecuritySettings((prev) => ({ ...prev, loginAlerts: e.target.checked }))
                                        }
                                        style={{
                                            width: "48px",
                                            height: "24px",
                                            cursor: "pointer",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* OTP Verification Modal */}
                    {showOTPModal && (
                        <div
                            className="modal show d-block"
                            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                            tabIndex="-1"
                        >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content" style={{ borderRadius: "12px", border: "none" }}>
                                    <div
                                        className="modal-header border-0 py-3 px-4"
                                        style={{
                                            background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                                            borderBottom: "1px solid #b3eaf4",
                                        }}
                                    >
                                        <h5 className="modal-title fw-bold" style={{ color: "#006e82" }}>
                                            Verify Action
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => {
                                                setShowOTPModal(false);
                                                setOtp("");
                                            }}
                                        />
                                    </div>
                                    <div className="modal-body p-4">
                                        <p style={{ color: "#64748b", fontSize: "14px" }}>
                                            An OTP has been sent to your registered mobile number. Please enter the 6-digit OTP to proceed.
                                        </p>
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold mb-2" style={{ color: "#006e82" }}>
                                                Enter OTP <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control text-center"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                                maxLength={6}
                                                placeholder="000000"
                                                style={{
                                                    borderRadius: "10px",
                                                    borderColor: "#b3eaf4",
                                                    fontSize: "24px",
                                                    letterSpacing: "8px",
                                                    fontWeight: "600",
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = "#006e82";
                                                    e.target.style.boxShadow = "0 0 0 0.2rem rgba(0, 110, 130, 0.1)";
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = "#b3eaf4";
                                                    e.target.style.boxShadow = "none";
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer border-0 p-4">
                                        <button
                                            type="button"
                                            className="btn fw-semibold"
                                            onClick={() => {
                                                setShowOTPModal(false);
                                                setOtp("");
                                            }}
                                            style={{
                                                borderRadius: "10px",
                                                borderColor: "#b3eaf4",
                                                color: "#006e82",
                                                backgroundColor: "transparent",
                                                padding: "10px 24px",
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn fw-semibold"
                                            onClick={handleVerifyOTPAndChangePassword}
                                            disabled={otp.length !== 6 || isSubmitting}
                                            style={{
                                                borderRadius: "10px",
                                                background: otp.length === 6 && !isSubmitting
                                                    ? "linear-gradient(135deg, #39b2b4 0%, #06b6a4 100%)"
                                                    : "#94a3b8",
                                                color: "white",
                                                border: "none",
                                                padding: "10px 24px",
                                            }}
                                        >
                                            {isSubmitting ? "Verifying..." : "Verify OTP"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
        </>
    );
}
